// extracted by mini-css-extract-plugin
export default {"icon":"Contact_icon__y5QDC"};